export default __webpack_public_path__ + "static/media/Maus.7c0d4e70.webp";